import { Component, OnInit, OnDestroy, OnChanges, SimpleChanges, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { paragraphDTO, sentenceDTO } from '@capiche/ts-data-models-shared';

import { CapicheMaterialModule } from 'capiche-material';
import { CapicheLoggerService } from 'capiche-logger';
import { DisclosurePath } from 'capiche-disclosure-path';

import { SentenceComponent } from '../sentence/sentence.component';
import { ComponentInstanceTracker } from '../../utils/component-instance-tracker';

@Component({
  selector: 'app-paragraph',
  standalone: true,
  imports: [CommonModule, CapicheMaterialModule, SentenceComponent],
  templateUrl: './paragraph.component.html',
  styleUrls: ['./paragraph.component.css'],
})
export class ParagraphComponent implements OnInit, OnChanges, OnDestroy {
  private readonly logger = new CapicheLoggerService('paragraph.component:', false);

  @Input({ required: true }) paragraph!: paragraphDTO;
  @Input({ required: true }) thisItemPath!: DisclosurePath;
  /** Editor instance identifier — threaded down to SentenceComponent → WordComponent → ReplacementService. */
  @Input({ required: true }) elId!: string;
  /**
   * The sentenceDTO.index of the sentence the cursor is currently inside, or null.
   * Passed down to each SentenceComponent so it can scroll itself into view and show an indicator.
   */
  @Input() activeSentenceIndex: number | null = null;

  /**
   * The sentenceDTO.index of the sentence the editor mouse is hovering over, or null.
   * Passed down to trigger sidebar scroll only — no visual indicator.
   */
  @Input() hoverSentenceIndex: number | null = null;

  childItemPaths: Record<number, DisclosurePath> = {};

  constructor() {
    this.logger.log('constructor');
    ComponentInstanceTracker.increment('ParagraphComponent');
  }

  ngOnInit() {
    this.logger.log('ngOnInit', this.paragraph);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['paragraph']) {
      const sentences = this.paragraph.sentences ?? [];
      this.childItemPaths = sentences.reduce<Record<number, DisclosurePath>>((acc, s) => {
        acc[s.index] = this.buildChildItemPath(s.index);
        return acc;
      }, {});
    }
  }

  ngOnDestroy() {
    this.logger.log('ngOnDestroy');
    ComponentInstanceTracker.decrement('ParagraphComponent');
  }

  buildChildItemPath(index: number): DisclosurePath {
    return {
      ...this.thisItemPath,
      sentenceIndex: index,
    };
  }

  // return true if component should be displayed
  get showComponent(): boolean {
    // TODO: this should be based on the paragraph state (editState and spellingState .. if 'dirty')
    return true;
  }

  trackByFn(index: number, item: sentenceDTO): number {
    return item.index;
  }
}
